import { useAppDispatch } from '@/app/store';
import { RotateCw } from 'lucide-react';
import { startNewChat } from '@/features/chat/chatSlice';

export default function Header() {
  const dispatch = useAppDispatch();
  const handleNewChat = () => dispatch(startNewChat());

  return (
    <header className="sticky top-0 z-10 flex justify-between items-center w-full max-w-screen-md mx-auto p-3 bg-white shadow-md ">
      <div className="flex items-center gap-2">
        <img src="/logo.svg" alt="SM AI Logo" className="h-8 w-8" />
        <h1 className="text-lg font-bold text-blue-800">SM AI: Raia</h1>
      </div>
      <button
        onClick={handleNewChat}
        className="flex items-center gap-1 px-3 py-2 rounded-xl bg-slate-100  hover:bg-slate-200  text-slate-700 text-sm"
      >
        {/* New Chat <NewChat size={16} /> */}
        Reset <RotateCw size={16} />
      </button>
    </header>
  );
}
